import Vue from 'vue'
import rpc from '../rpc.js'
import axios from 'axios'
import readTags from '../exif.js'
import * as moment from 'moment';

function initialState() {
    return {
        files: {},
        fileArr: [],
        allTags: {}
    }
}

export default {
    namespaced: true,
    state: initialState,
    mutations: {
        reset(state) {
            const s = initialState()
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        },
        newFile(state, uploadFile) {
            Vue.set(state.files, uploadFile.id, uploadFile);
            state.fileArr.push(uploadFile)
        },
        markImage(state, { id }) {
            Vue.set(state.files[id], "marked", true);
        },
        unMarkImage(state, { id }) {
            Vue.set(state.files[id], "marked", false);
        },
        fileStatusUpdate(state, fileID, percent) {
            if (percent == 100) {
                Vue.delete(state.files, fileID);
                return;
            }
            state.files[fileID].percent = percent;
        },
        addTagToFile(state, { id, tag }) {
            state.files[id].tags.push(tag);
        },
        addToAllTags(state, tag) {
            state.allTags[tag] = true;
        },
        delTagFromFile(state, obj) {
            let idx = state.files[obj.id].tags.indexOf(obj.tag);
            state.files[obj.id].tags.splice(idx, 1)
        },
        delFromAllTags(state, tag) {
            Vue.delete(state.allTags, tag);
        },
        uploadProgress(state, {fileId, percent}) {
            state.files[fileId].uploadProgress = percent;
        },
        fileUploaded(state, fileId) {
            //state.files[fileId].uploaded = true;
            let fileIdx = state.fileArr.indexOf(state.files[fileId]);
            Vue.delete(state.files, fileId);
            Vue.delete(state.fileArr, fileIdx);
        }
    },
    actions: {
        async updateTagsForImages({commit, state, dispatch}) {
            let result = await rpc.request("ImageService.UpdateTagsForImages", state.fileArr);
            console.log("update images:", result);
        },
        upload({ commit, state, dispatch }, obj) {
            dispatch("updateTagsForImages");
            dispatch("uploadNext");
        },
        async uploadNext({ commit, state, dispatch, rootState }, obj) {
            let uploadFile = null;
            for(let file of state.fileArr) {
                if(file.uploaded == false) {
                    uploadFile = file;
                    break;
                }
            }
            let formData = new FormData();
            formData.append("file", uploadFile.fileObject);
            let result = await axios.post(`api/images/${uploadFile.id}/file`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': rootState.token
                },
                onUploadProgress: (progressEvent) => {
                    let percentUploaded = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    commit("uploadProgress", {fileId: uploadFile.id, percent: percentUploaded})
                }
            })
            commit("fileUploaded", uploadFile.id);
            dispatch("uploadNext");
        },
        imageClick({ commit, state, dispatch}, {idx}) {
            for(let image of state.fileArr) {
                commit("unMarkImage", {id: image.id});
            }
            commit("markImage", {id: state.fileArr[idx].id});
        },
        imageCtrlClick({ commit, state, dispatch}, {idx}) {
            let image = state.fileArr[idx];
            if(image.marked) {
                commit("unMarkImage", {id: image.id});
            } else {
                commit("markImage", {id: image.id});
            }  
        },
        imageShiftClick({ commit, state, dispatch}, {idx}) {
            let clickedImage = state.fileArr[idx];
            let startSelected = false;
            let startClick = false;
            for(let image of state.fileArr) {
                if(image.marked) {
                    if(startClick) {
                        break;
                    }
                    startSelected = true;
                }
                if(image.id == clickedImage.id) {
                    if(startSelected) {
                        commit("markImage", {id: image.id});
                        break;
                    }
                    startClick = true;
                }
                if(startClick || startSelected) {
                    commit("markImage", {id: image.id});
                }
            }
        },
        delTagFromAll({ commit, state, dispatch }, tag) {
            commit('delFromAllTags', tag);
            for (let uploadFile of Object.values(state.files)) {
                if (uploadFile.tags.indexOf(tag) >= 0) {
                    commit('delTagFromFile', { id: uploadFile.id, tag: tag });
                }
            }
        },
        delTagFromFile({ commit, state, dispatch }, { id, tag }) {
            commit('delTagFromFile', { id, tag });
            let found = false;
            for (let uploadFile of Object.values(state.files)) {
                if (uploadFile.tags.indexOf(tag) >= 0) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                commit('delFromAllTags', tag);
            }
        },
        addTagsToFiles({ commit, state, dispatch }, options) {
            let noneMarked = Object.values(state.files).filter(uf => uf.marked).length == 0;
            for (let tag of options.tags) {
                commit('addToAllTags', tag);
                for (let uploadFile of Object.values(state.files)) {
                    if (noneMarked || uploadFile.marked)
                        if (uploadFile.tags.indexOf(tag) < 0) {
                            commit('addTagToFile', { id: uploadFile.id, tag })
                        }
                }
            }
        },
        async handleFileObjects({commit, state, dispatch }, fileEntries) {
            let filePromises = [];
            for (let entry of fileEntries) {
                let lowerName = entry.name.toLowerCase();
                if(!lowerName.endsWith("jpg") && !lowerName.endsWith("jpeg")) {
                    continue;
                }
                filePromises.push(new Promise(async resolve => {
                    if(entry.file) {
                        entry.file(async file => {
                            let tags = await readTags(file);
                            resolve({
                                file: file,
                                tags: tags,
                                entry: entry
                            });
                        })
                    } else {
                        console.log("else", entry)
                        let tags = await readTags(entry);
                        resolve({
                            file: entry,
                            tags: tags,
                            entry: {
                                name: entry.name,
                                fullPath: entry.webkitRelativePath + entry.name
                            }
                        });
                    }
                }))
            }
            Promise.all(filePromises).then(async files => {
                console.log(files)
                let jsonFiles = [];
                let fileMap = {};
                for (let f of files) {
                    let takenMoment = moment.utc(f.tags.DateTimeOriginal.description, "YYYY:MM:DD HH:mm:ss");
                    let taken = takenMoment.toDate();
                    jsonFiles.push({
                        name: f.entry.name,
                        relativePath: f.entry.fullPath,
                        lastModified: f.file.lastModified,
                        taken: taken,
                        size: f.file.size
                    })
                    fileMap[f.entry.fullPath] = f;
                }
                console.log("filemap", fileMap)
                console.log("before sending to server:", jsonFiles)
                let result = await rpc.request("ImageService.NewImages", jsonFiles);
                result.sort((a, b) => a.name.localeCompare(b.name));
                console.log("got back from server:", result)
                for (let uploadFile of result) {
                    //TODO: these files need to be uploaded.
                    uploadFile.fileObject = fileMap[uploadFile.relativePath].file;
                    uploadFile.exif = fileMap[uploadFile.relativePath].tags;
                    commit("newFile", uploadFile);
                }
            }).catch(error => {
                console.log("error oben:", error);
            })
        },
        async addUploadFilesDrag({ commit, state, dispatch }, options) {
            let addDirectory = async (item) => {
                let files = [];
                if (item.isDirectory) {
                    let dirEntries = await new Promise((resolve) => {
                        var directoryReader = item.createReader();
                        directoryReader.readEntries(entries => {
                            resolve(entries);
                        });
                    })
                    if (dirEntries.length > 0) {
                        for (let entry of dirEntries) {
                            let dirFiles = await addDirectory(entry);
                            for (let file of dirFiles) {
                                files.push(file);
                            }
                        }
                    }
                } else {
                    files.push(item);
                }
                return files;
            }
            let promises = [];
            for (let i = 0; i < options.webkitFolders.length; i++) {
                // If dropped items aren't files, reject them
                var item = options.webkitFolders[i].webkitGetAsEntry();
                if (item) {
                    promises.push(addDirectory(item));
                }
            }
            Promise.all(promises).then(filesArr => {
                let fileEntries = filesArr.flat();
                dispatch("handleFileObjects", fileEntries)
            })
        }
    }
}
